import React from 'react';
import { Button } from '@deal/components';
import LogoContainer from '../Logo/index.js';
import styles from './styles.css.js';

var NotFound = function NotFound() {
  return React.createElement("section", null, React.createElement("header", {
    className: styles.header
  }, React.createElement("a", {
    href: "/",
    className: styles.logo
  }, React.createElement(LogoContainer, {
    mark: "combo",
    color: "dark",
    className: styles.desktopIcon
  }), React.createElement(LogoContainer, {
    mark: "icon",
    color: "dark",
    className: styles.mobileIcon
  }))), React.createElement("div", {
    className: styles.image
  }, React.createElement("img", {
    src: "https://deal-img.imgix.net/static-shared/not-found_1f841158c1e84ba4.png"
  })), React.createElement("h1", {
    className: styles.headline
  }, "Oops. The page you were looking for doesn't exist."), React.createElement("p", {
    className: styles.body
  }, "You may have mistyped the address or the page has moved."), React.createElement("div", {
    className: styles.action
  }, React.createElement("a", {
    href: "https://www.curated.com"
  }, React.createElement(Button, null, "Take me home"))));
};

export default NotFound;
//# sourceMappingURL=index.js.map
